
"use strict";

var zeropadnum = require('../zeropadnum')
  , collections = require('../collections')
  , map     = collections.map
  , each    = collections.each
  , isArray = collections.isArray
  , RelativeInterval = require('../relativeinterval').RelativeInterval
  , Duration = require('../relativeinterval').Duration
  , push = [].push;

var SECOND_INTERVAL = 1000
  , MINUTE_INTERVAL = 60 * SECOND_INTERVAL
  , HOUR_INTERVAL = 60 * MINUTE_INTERVAL
  , TWO_HOUR_INTERVAL = 2 * 60 * MINUTE_INTERVAL
  , THREE_HOUR_INTERVAL = 3 * 60 * MINUTE_INTERVAL
  , TWELVE_HOUR_INTERVAL = 12 * 60 * MINUTE_INTERVAL
  , DAY_INTERVAL = 24 * HOUR_INTERVAL;

var granularityPeriodMap = {
  "minute":         "PT1M",
  "fifteen_minute": "PT15M",
  "thirty_minute":  "PT30M",
  "hour":           "PT1H",
  "two_hour":       "PT2H",
  "three_hour":     "PT3H",
  "twelve_hour":    "PT12H",
  "day":            "P1D",
  "seven_days":     "P7D",
  "thirty_days":    "P30D"   //or P1M?; P1M != P30D
};

var granularityMatch = exports.granularityMatch = /^(all|minute|fifteen_minute|thirty_minute|hour|two_hour|three_hour|twelve_hour|day|auto|seven_days|thirty_days)|(\d+)$/;

var MAX_AUTO_GRANULARITY_INTERVALS = 90;

var autoGranularityMaxIntervals = []
  , autoGranularityDurations = []
  , autoGranularityPeriods = [];

var durationNames = {
  "second": SECOND_INTERVAL,
  "minute": MINUTE_INTERVAL,
  "fifteen_minute": 15*MINUTE_INTERVAL,
  "thirty_minute": 30*MINUTE_INTERVAL,
  "hour": HOUR_INTERVAL,
  "two_hour": TWO_HOUR_INTERVAL,
  "three_hour": THREE_HOUR_INTERVAL,
  "twelve_hour": TWELVE_HOUR_INTERVAL,
  "day": DAY_INTERVAL,
  "seven_days": 7*DAY_INTERVAL,
  "thirty_days": 30*DAY_INTERVAL,
};

each([
 [60*SECOND_INTERVAL, SECOND_INTERVAL , "PT1S"],
 [ 30*MINUTE_INTERVAL, "minute"       , "PT1M"],
 [ HOUR_INTERVAL    , "minute"        , "PT1M"],
 [ 2*HOUR_INTERVAL  , "minute"        , "PT1M"],
 [ 3*HOUR_INTERVAL  , "fifteen_minute", "PT15M"],
 [ 12*HOUR_INTERVAL , "thirty_minute" , "PT30M"],
 [ 5*DAY_INTERVAL   , "hour"          , "PT1H"],
 [ 10*DAY_INTERVAL  , "two_hour"      , "PT2H"],
 [ 3*30*DAY_INTERVAL, "day"           , "P1D"],
 // [ 4*30*DAY_INTERVAL, "seven_days"    , "P7D"],
 // [ 6*30*DAY_INTERVAL, "thirty_days"   , "P30D"],
], function(tuple, index) {
  var maxInterval = tuple[0];
  if (index !== 0 && autoGranularityMaxIntervals[index - 1] >= maxInterval) {
    throw new Error("sanity error, each auto-granularity interval must be larger than previous");
  }
  autoGranularityMaxIntervals.push(tuple[0]);
  autoGranularityDurations.push(tuple[1]);
  autoGranularityPeriods.push(tuple[2]);
});

/**
 * Return auto granularity
 *
 * for interval 1 <= x < 3 months  - no more than 100 days
 * for interval 1 <= x < 3 months  - 1 day
 * for interval 14 <= x < 31 days  - 12 hours
 * for interval 7 <= x < 14 days  - 6 hours
 * for interval 4 <= x < 7 days  - 2 hours
 * for interval 2 <= x < 4 days  - 1 hour
 * for interval 1 <= x < 2 days  - 30 minutes
 * for interval 6 <= x < 24 hours  - 15 minutes
 * for interval 1 <= x < 6 hours - -  5 minutes
 * for interval 10 <= x < 60 minute -  1 minute
 * for interval 60 <= x < 600 seconds - 10 seconds
 * for interval x < 60 seconds - 1 second
 *
 * @param {Array} timeIntervals - array of timestamps determining time boundaries
 * @param {string} [timezone] - optional timezone
 * @return {string|object}
**/

/* find closest entry (with equal or greater first tuple item than searched) */
function bSearchIndex(entries, searched) {
  var lo = 0, hi = entries.length - 1;
  if (hi < 0) return;
  var mid = (lo + hi) >> 1;
  var found = entries[mid];
  while(lo < hi) {
    if (searched <= found) hi = mid; else lo = mid + 1;
    mid = (lo + hi) >> 1;
    found = entries[mid];
  }
  if (searched <= found) return mid;
}

exports.durationFromGranularity = function(granularity) {
  if ('string' === typeof granularity) {
    return durationNames[granularity] || 0;
  }

  if (granularity !== null && 'object' === typeof granularity) {
    switch(granularity.type) {
      case 'duration': return granularity.duration;
      case 'period': return new Duration(granularity.period).toMilliseconds();
    }
  }
};

/**
 * Return auto granularity
 *
 * @param {Array} timeIntervals - array of timestamps determining time boundaries
 * @param {string} [timezone] - optional timezone
 * @return {string|object}
**/
var autoGranularityFromIntervals = exports.autoGranularityFromIntervals = function(timeIntervals, timezone) {
  var granularity
    , delta = Math.max.apply(Math, timeIntervals) - Math.min.apply(Math, timeIntervals)
    , index = bSearchIndex(autoGranularityMaxIntervals, delta);

  if (index !== void 0) {
    if (timezone) {
      granularity = {type: "period", period: autoGranularityPeriods[index], timeZone: timezone};
    } else {
      granularity = autoGranularityDurations[index];
    }
  } else {
    granularity = Math.round(delta / MAX_AUTO_GRANULARITY_INTERVALS) - 1;
    granularity += DAY_INTERVAL - granularity % DAY_INTERVAL;

    if (timezone) {
      granularity = {type: "period", period: durationToPeriod(granularity), timeZone: timezone};
    }
  }

  if ('number' === typeof granularity) {
    if (granularity >= delta) {
      granularity = "all";
    }
    else {
      granularity = {type: "duration", duration: granularity};
    }
  }
  return granularity;
};

/**
 * Return period as ISO period
 *
 * @param {number} duration - in milliseconds
 * @return {string}
**/
var durationToPeriod = exports.durationToPeriod = function(duration) {
  duration = zeropadnum(duration.toFixed(0), 4);
  var seconds = duration.slice(0, -3)
    , millis = duration.slice(-3);
  return (millis === '000')  ? 
        'PT' + seconds + 'S' :
        'PT' + seconds + '.' + millis + 'S';
};

/**
 * Return granularity from number of intervals
 *
 * @param {number} numintervals - number of desired intervals
 * @param {Array} timeIntervals - array of timestamps determining time boundaries
 * @param {string} [timezone] - optional timezone
 * @return {string|object}
**/
var granularityFromIntervals = exports.granularityFromIntervals = function(numintervals, timeIntervals, timezone) {
  var delta = Math.max.apply(Math, timeIntervals) - Math.min.apply(Math, timeIntervals)
    , duration = Math.round(delta / numintervals);

  if (isFinite(duration)) {
    if (duration > 6*30*DAY_INTERVAL)
      duration -= (duration % 30*DAY_INTERVAL);
    else if (duration > 3*30*DAY_INTERVAL)
      duration -= (duration % 7*DAY_INTERVAL);
    else if (duration > DAY_INTERVAL)
      duration -= (duration % DAY_INTERVAL);
    else if (duration > TWELVE_HOUR_INTERVAL)
      duration -= (duration % TWELVE_HOUR_INTERVAL);
    else if (duration > THREE_HOUR_INTERVAL)
      duration -= (duration % THREE_HOUR_INTERVAL);
    else if (duration > TWO_HOUR_INTERVAL)
      duration -= (duration % TWO_HOUR_INTERVAL);
    else if (duration > HOUR_INTERVAL)
      duration -= (duration % HOUR_INTERVAL);
    else if (duration > MINUTE_INTERVAL)
      duration -= (duration % MINUTE_INTERVAL);
    else if (duration > SECOND_INTERVAL)
      duration -= (duration % SECOND_INTERVAL);
    else
      duration = SECOND_INTERVAL;

    if (duration >= delta) {
      duration = delta;
    }
  }
  else {
    duration = delta;
  }

  if (timezone) {
    return {type: "period", period: durationToPeriod(duration), timeZone: timezone};
  } else if (duration === delta) {
    return "all";
  } else {
    return {type: "duration", duration: duration};
  }
};

/**
 * Return normalized granularity
 *
 * NOTE: `granularity` may be a number, a string number in which case it is a number of intervals
 *       or one of "auto", "minute", "fifteen_minute", "thirty_minute", "hour", "day", "all"
 *       or an ISO period
 *
 * `timeIntervals` may contain Date objects as well as timestamps as numbers
 *
 * @param {number|string} granularity - as a number of intervals or granularity string
 * @param {Array} timeIntervals - array of timestamps determining time boundaries
 * @param {string} [timezone] - optional timezone
 * @return {string|object}
**/
var normalizeGranularity = exports.normalizeGranularity = function normalizeGranularity(granularity, timeIntervals, timezone) {
  var match;

  switch(typeof granularity) {
    case 'number':
      return granularityFromIntervals(granularity, timeIntervals, timezone);
    case 'string':
      match = granularity.match(granularityMatch);
      break;
    default:
      granularity = null;
  }

  if (match) {
    if (match[2]) {
      return granularityFromIntervals(parseInt(match[2]), timeIntervals, timezone);
    } else {
      switch(match[1]) {
        case 'auto':
          break;
        case 'all':
          return 'all';
        default:
          return timezone ? {type: "period", period: granularityPeriodMap[match[1]], timeZone: timezone}
                          /* one of druid duration string literals */
                          : match[1];
      }
    }
  } else if (granularity) {
    /* granularity only survives here as a string that didn't match granularityMatch
       so assume it's a literal ISO period */
    granularity = new Duration(granularity).toString();
    return timezone ? {type: "period", period: granularity, timeZone: timezone}
                    : {type: "period", period: granularity};
  }
  /* the "auto" or default */
  return autoGranularityFromIntervals(timeIntervals, timezone);
};


/**
 * Return intervals as an array of RelativeInterval objects
 *
 * intervals may be any ISO8601 duration with relative "#" placeholders
 *
 * see RelativeInterval
 *
 * @param {Array|string} intervals
 * @param {string} [timezone] - default timezone for no-timezone specified intervals
 * @return {Array}
**/
exports.parseIntervals = function(intervals, timezone) {
  if ('string' === typeof intervals && intervals.length !== 0) {
    return [new RelativeInterval(intervals, timezone)];
  }

  if (!isArray(intervals) || intervals.length === 0) {
    throw TypeError("intervals should be an array of ISO 8601 time interval strings");
  }

  return map(intervals, function(interval) {
    return new RelativeInterval(interval, timezone);
  });
};

/**
 * Return flat array of date pairs from RelativeInterval objects
 *
 * intervals must be an array of RelativeInterval objects
 *
 * @param {Array} intervals
 * @param {Date|number} [refdate]
 * @return {Array}
**/
exports.intervalsToDates = function(intervals, refdate) {
  refdate || (refdate = new Date());

  var dates = [];

  for(var i = 0, len = intervals.length; i < len; ++i) {
    push.apply(dates, intervals[i].toDates(refdate));
  }

  return dates;
};

/**
 * Return intervals as an array of ISO 8601 time interval strings
 *
 * dates must be an array of even number of Date objects
 *
 * @param {Array} dates
 * @return {Array}
**/
exports.datesToISOIntervals = function(dates) {
  var intervals = [];

  for(var i = 0, len = dates.length; i < len; i += 2) {
    intervals.push(dates[i].toISOString() + '/' + dates[i + 1].toISOString());
  }

  return intervals;
};

exports.strictDatesToISOIntervals = function(dates) {
    var intervals = [];

    for(var i = 0, len = dates.length; i < len; i += 2) {
        intervals.push(dates[i] + '/' + dates[i + 1]);
    }

    return intervals;
};

